import styled from 'styled-components';

export default styled.input`
  /* box-shadow: inset 0px 1px 5px 0px rgba(125, 125, 125, 0.3); */
  /* background-color: #f0f0f0; */
  /* border: none; */
  background-color: #fff;
  border: 1px solid #ccc;
  color: #555;
  width: ${props => (props.width ? props.width : '100%')};
  padding: 8px;
  font-size: 1.2rem;
  /* margin: 10px; */
  border-radius: 5px;
  margin-right: 5px;

  &::placeholder {
    color: #c6c6c6;
  }

  &:disabled {
    background-color: #f5f5f5;
    box-shadow: unset;
    cursor: not-allowed;
  }
`;
